import {
  FileContentType,
  FileType,
  IFileRefGetBaseName,
  IFileRefGetCleanPath,
  IFileReference,
  IFileRefIsLocal
} from '@summit/core';
import { EboObject } from '../base-classes/ebo-object';

export class TruckFile extends EboObject implements IFileReference {
  truckID: string;
  name: string;
  path: string;
  blobPath: string; // Required for dynamic file loading
  order: number;
  fileType: FileType;
  contentType: FileContentType;

  constructor(jsonData: Partial<TruckFile>) {
    super(jsonData);
    this.contentType ??= FileContentType.Attachment;
  }

  get baseName(): string {
    return IFileRefGetBaseName(this);
  }
  get cleanPath(): string {
    return IFileRefGetCleanPath(this);
  }
  get isLocal(): boolean {
    return IFileRefIsLocal(this);
  }
}
